import { create } from 'zustand';

type TextZoneState = {
  id: string;
  number: number;
} | null;

interface TextZoneStore {
  sourceAddToZone: TextZoneState;
  setSourceAddToZone: (newState: TextZoneState) => void;

  targetAddToZone: TextZoneState;
  setTargetAddToZone: (newState: TextZoneState) => void;
}

export const useTextZoneStateStore = create<TextZoneStore>((set, get) => ({
  sourceAddToZone: null,
  setSourceAddToZone: (newState: TextZoneState) => {
    set(() => ({
      sourceAddToZone: newState,
    }));
  },
  targetAddToZone: null,
  setTargetAddToZone: (newState: TextZoneState) => {
    set(() => ({
      targetAddToZone: newState,
    }));
  },
}));
